import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function AddendumIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 7.00016V4.5335C12.5 3.41339 12.5 2.85334 12.2956 2.42552C12.1159 2.04919 11.829 1.74323 11.4762 1.55148C11.0751 1.3335 10.5501 1.3335 9.5 1.3335H5.5C4.4499 1.3335 3.92485 1.3335 3.52377 1.55148C3.17096 1.74323 2.88413 2.04919 2.70436 2.42552C2.5 2.85334 2.5 3.41339 2.5 4.5335V11.4668C2.5 12.5869 2.5 13.147 2.70436 13.5748C2.88413 13.9511 3.17096 14.2571 3.52377 14.4488C3.92485 14.6668 4.4499 14.6668 5.5 14.6668H7.5M8.75 7.3335H5M6.25 10.0002H5M10 4.66683H5M11.25 14.0002V10.0002M9.375 12.0002H13.125"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
